<template>
  <div class="PageHeader">
	<div>
		<span class="logo">ICE</span>
	</div>
	<div>
		<button @click="gotoImport">Import</button>
		<button @click="gotoHistory">History</button>
		<button @click="gotoArap">Debi/Kredi</button>
		<button @click="gotoConfig">Verwaltung</button>
		<button @click="openClientSelect" class="btnclient">Mandant: {{ $store.state.customer.name }}</button>
	</div>
	<div>
		<a class="signout" @click="logout" title="Sign out"><i class="fas fa-sign-out-alt"></i></a>
	</div>
	
	<modal name="globalClientSelect" width="450" height="auto" :clickToClose="false" draggable=".delConf-title" @opened="$refs.fldsearch.focus()">
		<div class="delConf-title">Mandant auswählen</div>
		<div class="delConf-content clientselect">
			<input type="text" v-model="search_txt" placeholder="Suche..." @keyup.enter="search" class="left_space" ref="fldsearch"><br>
			<select v-model="selected_client" size="6">
				<option v-for="(client,idxclient) in clients" :key="idxclient" :value="client.id">{{ client.name }}</option>
			</select>
		</div>
		<div class="delConf-button-wrapper">
			<button @click="selectClient">OK</button>
			<button @click="$modal.hide('globalClientSelect')">Abbrechen</button>
		</div>
	</modal>
  </div>
</template>

<script>
  import ApiComm from '../../apicomm.js'
  import axios from 'axios'
  
  export default {
    name: "PageHeader",
    components: {},
    mixins: [ApiComm],
	data() {
		return {
			search_txt: '',
			selected_client: '',
			clients: []
		}
    },
    computed: {},
    methods: {
      gotoImport: function () {
        this.$router.push({ path: '/home/import/upload'})
      },
      gotoHistory: function () {
        this.$router.push({ path: '/home/history'})
      },
      gotoArap: function () {
        this.$router.push({ path: '/home/arap'})
      },
      gotoConfig: function () {
        this.$router.push({ path: '/home/configuration'})
      },
      openClientSelect: function () {
		this.search_txt = ''
		this.selected_client = ''
		this.apiCall([{method: 'userclient/list', param: {user_id: this.$store.state.auth.user_id}, id: 5}], this.evalApiResponse)
        this.$modal.show('globalClientSelect')
      },
      search: function () {
		  this.apiCall([{method: 'userclient/list', param: {user_id: this.$store.state.auth.user_id, quicksearch: this.search_txt}, id: 5}], this.evalApiResponse)
      },
      selectClient: function () {
		  if (this.selected_client === '') return
		  
		  this.$store.state.customer.id = this.selected_client
		  var i
		  for(i=0; i<this.clients.length; i++) {
			  if (this.clients[i].id === this.selected_client) {
				  this.$store.state.customer.name = this.clients[i].name
				  this.$store.state.customer.accounting_tool = this.clients[i].accounting_tool
				  this.$modal.hide('globalClientSelect')
				  return
			  }
		  }
		  this.$modal.hide('globalClientSelect')
		  this.$store.state.customer.name = ''
      },
      logout: function () {
		this.apiCall([{method: 'core/logout', param: {uid: this.uid, pwd: this.pwd}}], this.evalApiResponse)
        this.$store.commit('logout')
        this.$router.push({ path: '/login'})
      },
      evalApiResponse: function (resp) {
        var vm = this
        this.$_.forEach(resp, function (value) {
          if (value.hasOwnProperty('id')) {
            switch (value.id) {
              case 5: // 5 = Result from 'userclient/list'
				vm.clients = value.result
                break
            }
          }
        })
      }
    },
    mounted: function () {
		if (this.$store.state.customer.id === 0) this.openClientSelect()
    }
  }
</script>

<style scoped="">
.PageHeader {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center; 
	background-color: #888;
	height: 75px;
}

button {
	cursor: pointer;
	margin: 0 10px;
	padding: 0 20px;
	background-color: #888;
	border: 1px solid #aaa;
	color: #fff;
	line-height:40px;
	font-weight: 700;
}

button:hover {
	background-color: #666;
}

.btnclient {
	background-color: #8a8;
}

.signout {
	color: #fff;
	font-size: 30px;
	margin-right:20px;
}

.logo {
	margin-left:20px;
	color: #fff;
	font-weight:700;
	font-size:30px;
}

/* CONFIRM DELETION*/
.delConf-title {
	cursor: move;
	font-weight: 700;
	line-height: 40px;
	border-bottom: 1px solid #aaa;
	padding: 0 10px;
}

.delConf-content {
	padding: 20px 10px;
}

.delConf-button-wrapper {
	border-top: 1px solid #aaa;
	padding: 10px 10px 0 10px;
}

.delConf-button-wrapper button {
	margin-left: 5px;
}

.delConf-btn-del {
	background: #c00;
}

.delConf-btn-del:hover {
	background: #a00;
}

.clientselect input, .clientselect select {
	width:100%;
	background: #fff;
	border: 1px solid #888;
	margin: 2px 0;
	padding: 3px;
}

.delConf-button-wrapper button {
	border: 1px solid #000;
	background: #888;
	color: #fff;
	margin-bottom: 20px;
	padding: 5px 10px;
	cursor: pointer;
	font-weight: 700;
	height: auto;
	line-height: inherit;
}
</style>
